import { shortFormsEnabled } from '../../../brand/tenant';
import { IS_PROD_STAND } from '../../../constants';

// Анкета серого дилера: платёж всегда аннуитетный, день погашения — день подачи заявки.
// Поля менеджеру не показываем — подставляем при отправке.
export const ANNUITY_REPAYMENT_TYPE = 0;

// Банки принимают день погашения только с 1 по 23 (та же граница в проверке поля анкеты).
export const MAX_REPAYMENT_DAY = 23;

export const repaymentDayOf = (date = new Date()) => Math.min(date.getDate(), MAX_REPAYMENT_DAY);

export const REPAYMENT_FIELDS = ['repaymentType', 'repaymentDay'];

export const withoutRepaymentFields = (inputs, short = shortFormsEnabled()) =>
  short ? inputs.filter((input) => !REPAYMENT_FIELDS.includes(input.name)) : inputs;

// Галочки анкеты (субсидия, рассрочка, первичная регистрация, льготное кредитование) серым не нужны:
// их нет на экране, и значения из старого черновика в заявку не попадают.
export const flagFromDraft = (value, short = shortFormsEnabled()) => !short && !!value;

// Подпись согласия через ОТП у серых только на тесте — чтобы было чем подписывать; на проде кнопки нет.
export const otpSignAllowed = (short = shortFormsEnabled(), prod = IS_PROD_STAND) => !(short && prod);

// Статусы клиента, которые остаются у серых: обычный (ГЦВП), с выпиской БВУ, военнослужащий.
export const GREY_WORK_STATUS_IDS = ['0', '9', '3'];

export const workStatusOptions = (options, short = shortFormsEnabled()) =>
  short ? options.filter((option) => GREY_WORK_STATUS_IDS.includes(String(option.value))) : options;

// Что уходит в заявку вместо скрытых полей.
export const repaymentPayload = (values, short = shortFormsEnabled(), date = new Date()) =>
  short
    ? { repaymentType: ANNUITY_REPAYMENT_TYPE, repaymentDay: repaymentDayOf(date) }
    : {
        repaymentType: values?.repaymentType?.value,
        repaymentDay: values?.repaymentDay ? +values?.repaymentDay?.replace(/\s/g, '') : 0,
      };
